import type { Error } from '../types';

export const allowedLength =
  (ranges: number[], message?: Error['message']) =>
  (value: string): Error => ({
    valid: ranges.includes(value?.length),
    message
  });
